<template>
  <sdCards :title="$t('pages.apps.seo.title')">
    <a-form layout="vertical" :model="formData" @submit="handleSubmit">
      <a-form-item :label="$t('pages.apps.seo.input-title')">
        <a-input v-model:value="app.seo_title" />
      </a-form-item>
      <a-form-item :label="$t('pages.apps.seo.desc')">
        <a-textarea v-model:value="app.seo_description" :placeholder="$t('pages.apps.seo.desc')" :rows="2" />
      </a-form-item>
      <a-form-item :label="$t('pages.apps.seo.keywords')">
        <a-input v-model:value="app.seo_keywords" />
      </a-form-item>
      <a-form-item label="&nbsp;">
        <a-button type="primary" :loading="iconLoading" html-type="submit"> {{ $t('common.save') }} </a-button>
      </a-form-item>
    </a-form>
  </sdCards>
</template>
<script>
import { mapGetters } from 'vuex';
export default {
  name: 'Seo',
  components: {},
  data() {
    return {
      app_id: this.$route.params.id,
      iconLoading: false,
      formData: {},
    };
  },
  methods: {
    handleSubmit() {
      this.formData = {
        app_id: this.app_id,
        seo_title: this.app.seo_title,
        seo_description: this.app.seo_description,
        seo_keywords: this.app.seo_keywords,
      };

      this.$appAxios.post(this.$endpoints.app_seo_update, this.formData).then((resp) => {
        if (resp.data.status) {
          this.$message.success(this.$t('common.success-message'));
        } else {
          this.$message.error(resp.data.message);
        }
      });
    },
  },
  computed: {
    ...mapGetters({
      app: 'application/app_detail',
    }),
  },
};
</script>
